// extracted by mini-css-extract-plugin
export default {"benefitsJoinContainer":"RUou9PPp8bdhtfzkojDC","listContainer":"wDFMehofVnw0gjhBb2jk","listContent":"ra2mHZxfcdYrYw5NeLoo","fullList":"L5XRBqLU3rEdOPn1KMdl"};